import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { api } from "../../helper/api.interceptor";
import Swal from "sweetalert2";

function Requirement() {
    const [bannerData, setBannerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchBanners();
    }, []);

    const fetchBanners = async () => {
        try {
            setLoading(true);
            const banners = await api.getOfferBanner(); // Fetch banners
            setBannerData(banners);
        } catch (err) {
            setError("Failed to load banners. Please try again.");
            console.error("Error fetching banners:", err);
        } finally {
            setLoading(false);
        }
    };
    const deleteBanner = async (banner_id) => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the banner.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (confirmDelete.isConfirmed) {
            try {
                console.log(banner_id);

                const response = await api.removeOfferBanner(banner_id);
                console.log("Delete response:", response);

                if (response.status_code === 200) {
                    Swal.fire("Deleted!", "The banner has been removed.", "success");

                    // Remove the deleted banner from UI
                    setBannerData(bannerData.filter((b) => b.bannerId !== banner_id));
                } else {
                    Swal.fire("Error", "Failed to delete banner. Please try again.", "error");
                }
            } catch (err) {
                console.error("Error deleting banner:", err);
                Swal.fire("Error", "Server error. Please try again later.", "error");
            }
        }
    };

    return (
        <div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
                <h6 className="fw-semibold mb-0">
                    <Icon
                        icon="mdi:ticket-percent"
                        className="menu-icon"
                        style={{ width: "30px", height: "30px" }}
                    />{" "}
                    | Offers Banners
                </h6>
                <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 text-decoration-none text-muted hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="text-lg" />
                            Customers
                        </Link>
                    </li>
                    <li>-</li>
                    <li className="fw-medium text-dark">Offer Banners</li>
                </ul>
            </div>


            <div className="card border-0 shadow rounded-3 overflow-hidden">
                <div className="card-header bg-white py-3 px-4 border-bottom d-flex justify-content-end">
                    <button
                        onClick={() => navigate("/banner/add")}
                        className="btn btn-warning rounded-pill px-100 fw-medium d-flex align-items-center gap-2"
                    >
                        <Icon icon="mdi:plus" className="fs-5" />
                        Add New Banner
                    </button>
                </div>

                <div className="card-body">
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-warning" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3 text-muted">Loading banners...</p>
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger rounded-3 d-flex justify-content-between align-items-center">
                            <span>{error}</span>
                            <button
                                className="btn btn-sm btn-outline-danger rounded-pill"
                                onClick={() => window.location.reload()}
                            >
                                Retry
                            </button>
                        </div>
                    ) : bannerData.length > 0 ? (
                        <div className="row g-4">
                            {bannerData.map((banner, index) => (
                                <div className="col-xl-4 col-lg-6 col-md-6" key={index}>
                                    <div className="card h-100 border-0 shadow-sm rounded-3 overflow-hidden hover-scale">
                                        <div className="position-relative banner-image">
                                            {banner.image ? (
                                                <img
                                                    src={banner.image}
                                                    alt={banner.title}
                                                    className="w-100 h-100 object-fit-cover"
                                                />
                                            ) : (
                                                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-muted bg-light">
                                                    <Icon icon="mdi:image-off" className="fs-2 mb-2" />
                                                    <p className="mb-0">No Image Available</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className="card-footer bg-white border-0 d-flex justify-content-between align-items-center py-3">
                                            <h5 className="fw-semibold mb-0 text-dark">{banner.title}</h5>
                                            <div className="d-flex gap-2">
                                                {/* <button
                                                    className="btn btn-sm btn-outline-primary rounded-circle"
                                                    onClick={() => navigate(`/banner/edit/${banner.bannerId}`)}
                                                >
                                                    <Icon icon="mdi:pencil-outline" className="fs-5" />
                                                </button> */}
                                                <button
                                                    className="btn btn-sm btn-outline-danger rounded-circle"
                                                    onClick={() => deleteBanner(banner.bannerId)}
                                                >
                                                    <Icon icon="mdi:delete-outline" className="fs-5" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <Icon icon="mdi:image-off" className="fs-1 text-muted mb-3" />
                            <h5 className="fw-semibold text-muted">No Banners Available</h5>
                            <p className="text-muted">Add your first banner to get started.</p>
                            <button
                                onClick={() => navigate("/banner/add")}
                                className="btn btn-warning rounded-pill px-4 d-inline-flex align-items-center gap-2"
                            >
                                <Icon icon="mdi:plus" />
                                Create Banner
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Requirement;
